module.exports = __webpack_public_path__ + "img/business_02.61e3d7d0.jpg";